import { render, staticRenderFns } from "./UploadWatchlist.vue?vue&type=template&id=065097e8&"
import script from "./UploadWatchlist.ts?vue&type=script&lang=ts&"
export * from "./UploadWatchlist.ts?vue&type=script&lang=ts&"
import style0 from "./UploadWatchlist.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports